import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import * as Cookies from 'js-cookie'
import { FormData } from '@/store/modules/FormData'
import { Routing } from '@/store/modules/Routing'
import { ErrorData } from '@/store/modules/ErrorData'
import { ConfirmationData } from '@/store/modules/ConfirmationData'
import { Auth } from '@/store/modules/Auth'
import { Basket } from '@/store/modules/Basket'

const dataState = createPersistedState(
{
    // storage:
    // {
    //     getItem: (key) => Cookies.get(key),
    //     setItem: (key, value) => Cookies.set(key, value, { expires: 1, secure: true }),
    //     removeItem: (key) => Cookies.remove(key)
    // },
    storage: window.sessionStorage,
    paths:
    [
        'formData',
        'auth',
        'basket'
    ]
})

export default createStore(
{
    modules:
    {
        formData: FormData,
        routing: Routing,
        errors: ErrorData,
        confirmations: ConfirmationData,
        auth: Auth,
        basket: Basket
    },
    plugins: [dataState]
})
